import React from "react";
import TableHeader from "./TableHeader";
import CustomTable from "./CustomTable";
import Nodata from "../../Icons/NoData";

export default function NoDataTable({
  queryChange,
  columns,
  message,
  onResetClick,
  calcHeight
}) {
  const handleResetClick = () => {
    if (typeof onResetClick === "function") onResetClick();
    window.location.href = `${window.location.pathname}?page=1&perPage=20`;
  };

  return (
    <div
      className="pb-3"
      style={{
        height: "calc(100vh - 60px)",
        position: "relative",
      }}
    >
      <div className="absolute top-0 bottom-3 left-0 right-0 flex flex-col items-center justify-center">
        <p className="text-xl dark:text-gray-500 text-gray-800 mt-2">
          {message || "There is nothing here"}
        </p>
        {queryChange && (
          <div className="mt-3">
            <button
              className="
                flex-shrink-0
                inline-flex
                items-center
                text-xs
                px-2
                py-2
                font-semibold
                text-white
                rounded-sm
                shadow-md
                focus:outline-none
                focus:ring-2
                focus:ring-pink-500
                focus:ring-offset-2
                focus:ring-offset-pink-200
                bg-gradient-to-r
                from-yellow-400
                via-red-500
                to-pink-500
                hover:from-pink-500
                hover:via-red-500
                hover:to-yellow-400
                transition-all
                hover:delay-75
              "
              type="button"
              onClick={handleResetClick}
            >
              <span className="text-md">RESET FILTER</span>
            </button>
          </div>
        )}

        {/* <div className="absolute bottom-0 left-0 right-0 flex flex-col items-center justify-center">
          <Nodata />
        </div> */}
      </div>
      <CustomTable calcHeight={calcHeight}>
        <TableHeader columns={columns} />
      </CustomTable>
    </div>
  );
}
